import React from "react";
import AdminPagination from "../admin/AdminPagination";

export default function PublicPagination(props) {
  return <AdminPagination {...props} variant="public" />;
}
